<script>
import { menuItems } from "./menu";
import MetisMenu from "metismenujs/dist/metismenujs";

/**
 * Sidenav component
 */
export default {
  components: {  },
  data() {
    return {
      menuItems: [],
      menuData: null,
    };
  },
  async mounted() {
    
    await menuItems()
      .then((menu) => {
        this.menuItems = menu
      });
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    // console.log(":: paths ::",paths,window.location.pathname);
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      // console.log("11",JSON.stringify(item),links);
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      // console.log("00",itemIndex,links);
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      // this.isActive(window.location.pathname);
      var disabledParent = true;// 
      if (parent && !disabledParent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  },
  
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      var isHiddenCounts = 0,
          return_data = item.subItems !== undefined ? item.subItems.length > 0 : false;
      if(return_data){
        for(let x of item.subItems){
          if(this.objOwnProperty(x, "isHidden")){
            if(x.isHidden){
              isHiddenCounts++;
            }
          }
        }
        return_data = isHiddenCounts == item.subItems.length ? false : return_data;
      }
      return return_data;
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },
    isBootstrapIcon(icon) {
      if (!icon) return false;
      // icon can be a class string like 'bi bi-person-workspace' or 'bi-person-workspace'
      return icon.indexOf('bi-') !== -1 || icon.startsWith('bi ');
    },
    isMaterialIcon(icon) {
      if (!icon) return false;
      // support strings like 'mdi mdi-account-circle' or 'mdi-account-circle'
      return icon.indexOf('mdi') !== -1;
    },
    isGoogleMaterialIcon(icon) {
      if (!icon) return false;
      // support tokens like:
      // 'material person_pin' (classic),
      // 'material-outlined person_pin' (classic outlined),
      // 'material-symbols-outlined person_pin' (Material Symbols variable font)
      return /^(material|material-outlined|material-symbols|material-symbols-outlined|material-symbols-rounded|material-symbols-sharp|mi)\b/.test(icon);
    },
    materialIconClass(icon) {
      if (!icon) return 'material-symbols-outlined nav-icon';
      if (icon.startsWith('material-symbols-outlined')) return 'material-symbols-outlined nav-icon';
      if (icon.startsWith('material-symbols-rounded')) return 'material-symbols-rounded nav-icon';
      if (icon.startsWith('material-symbols-sharp')) return 'material-symbols-sharp nav-icon';
      if (icon.startsWith('material-symbols')) return 'material-symbols nav-icon';
      if (icon.startsWith('material-outlined')) return 'material-icons-outlined nav-icon';
      if (icon.startsWith('material')) return 'material-icons nav-icon';
      return 'material-symbols-outlined nav-icon';
    },
    materialIconName(icon) {
      if (!icon) return '';
      const parts = icon.split(/\s+/);
      return parts.slice(1).join(' ') || '';
    },
    isActive(route, subitem = null){
      // console.log("current route",this.$route.name,JSON.stringify(route),JSON.stringify(subitem));
      var return_data = {"active_parent": false,"active_child":false};
      try {
        if(this.objOwnProperty(route,"subItems")){
            if(subitem != null){
              //this will enable active class when child option isHidden is not equal to true
              if(this.$route.name == subitem.link.name){
                return_data.active_parent = true;
                return_data.active_child = true;
              }
            }else{
              //this will enable active class when child option isHidden true
              for(let s of route.subItems){
                if(this.$route.name == s.link.name){
                  return_data.active_parent = true;
                  return_data.active_child = true;
                }
              }
            }
          }
          if(this.$route.name == route.link.name){
            return_data.active_parent = true;
          }
      } catch (error) {
        console.log("error",error.toString());
      }
      // console.log(" :::::::: return_data",return_data);
      return return_data;
    },
    objOwnProperty(obj,prop){
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
        <li>
          <router-link
            :to="{ name: 'wallet-topup' }"
            class="side-nav-link-ref wallet-link hidden"
          >
            <img src="@/assets/images/wallet.png" />
            <span>Wallet</span>
          </router-link>
        </li>
        <hr />
      <template v-for="(item, index) in menuItems">
        <li class="menu-title" v-if="item.isTitle" :key="index">
          {{ $t(item.label) }}
        </li>
        <li class="ps-2 pe-2" v-if="item.isSeparator" :key="index">
          <hr />
        </li>
        <li :class="{'mm-active':isActive(item).active_parent}" v-if="!item.isSeparator && !item.isTitle && !item.isLayout" :key="index">
          <a
            v-if="hasItems(item) && !item.isDisabled"
            href="javascript:void(0);"
            class="is-parent"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
              <span v-if="item.icon">
                <i v-if="isGoogleMaterialIcon(item.icon)" :class="materialIconClass(item.icon)">{{ materialIconName(item.icon) }}</i>
                <i v-else-if="isMaterialIcon(item.icon)" :class="item.icon + ' nav-icon'"></i>
                <i v-else-if="isBootstrapIcon(item.icon)" :class="item.icon + ' nav-icon'"></i>
                <feather v-else :type="`${item.icon}`" class="icon nav-icon"></feather>
              </span>
            <span>{{ $t(item.label) }}</span>
            <span
              :class="`badge rounded-pill bg-${item.badge.variant} float-end`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span>
          </a>
          <a
            style="pointer-events: none;"
            v-if="hasItems(item) && item.isDisabled"
            disabled
            href="javascript:void(0);"
            class="disabled-item"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <span v-if="item.isDisabled">
              <i v-if="isGoogleMaterialIcon(item.icon)" :class="materialIconClass(item.icon) + ' disabled-icon disabled-item'">{{ materialIconName(item.icon) }}</i>
              <i v-else-if="isMaterialIcon(item.icon)" :class="item.icon + ' disabled-icon disabled-item'"></i>
              <i v-else-if="isBootstrapIcon(item.icon)" :class="item.icon + ' disabled-icon disabled-item'"></i>
              <feather v-else :type="`${item.icon}`" class="icon disabled-icon disabled-item"></feather>
            </span>
            <span class="disabled-item">{{ $t(item.label) }}</span>
          </a>
          <router-link
            :to="item.link"
            v-if="!hasItems(item) && !item.isDisabled"
            class="side-nav-link-ref"
          >
            <span v-if="item.icon">
              <i v-if="isGoogleMaterialIcon(item.icon)" :class="materialIconClass(item.icon)">{{ materialIconName(item.icon) }}</i>
              <i v-else-if="isMaterialIcon(item.icon)" :class="item.icon + ' nav-icon'"></i>
              <i v-else-if="isBootstrapIcon(item.icon)" :class="item.icon + ' nav-icon'"></i>
              <feather v-else :type="`${item.icon}`" class="icon nav-icon"></feather>
            </span>
            <span>{{ $t(item.label) }}</span>
            <span
              :class="`badge rounded-pill bg-${item.badge.variant} float-end`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </router-link>
          <!--disabled item-->
          <a href="#" v-if="!hasItems(item) && item.isDisabled" class="side-nav-link-ref">
            <span v-if="item.icon">
              <i v-if="isGoogleMaterialIcon(item.icon)" :class="materialIconClass(item.icon) + ' disabled-icon disabled-item'">{{ materialIconName(item.icon) }}</i>
              <i v-else-if="isMaterialIcon(item.icon)" :class="item.icon + ' disabled-icon disabled-item'"></i>
              <i v-else-if="isBootstrapIcon(item.icon)" :class="item.icon + ' disabled-icon disabled-item'"></i>
              <feather v-else :type="`${item.icon}`" class="icon disabled-icon disabled-item"></feather>
            </span>
            <span class="disabled-item">{{ $t(item.label) }}</span>
            <span class="disabled-item"
              :class="`badge rounded-pill bg-${item.badge.variant} float-end`"
              v-if="item.badge"
              >{{ $t(item.badge.text) }}</span
            >
          </a>

          <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false" :disabled="item.isDisabled">
            <div v-if="!item.isDisabled">
              <li :class="{'mm-active':isActive(item,subitem).active_child}" v-for="(subitem, index) of item.subItems" :key="index">
                <router-link v-if="!hasItems(subitem) && subitem.link !== undefined && !subitem.isDisabled"
                  :to="subitem.link"
                  :disabled="subitem.isDisabled"
                  class="side-nav-link-ref"
                  :class="{'disabled-item': subitem.isDisabled}"
                  >{{ $t(subitem.label) }}</router-link
                >
                <router-link v-if="!hasItems(subitem) && subitem.link !== undefined && subitem.isDisabled"
                  :to="{ path: '' }"
                  class="disabled-item"
                  >
                  <span class="disabled-item">
                    {{ $t(subitem.label) }}
                  </span>
                </router-link>
                <a
                  v-if="hasItems(subitem)"
                  :disabled="subitem.isDisabled"
                  class="side-nav-link-a-ref has-arrow"
                  href="javascript:void(0);"
                  >{{ $t(subitem.label) }}</a
                >
                <ul
                  v-if="hasItems(subitem)"
                  :disabled="subitem.isDisabled"
                  class="sub-menu mm-collapse"
                  aria-expanded="false"
                >
                
                  <li
                    v-for="(subSubitem, index) of subitem.subItems"
                    :key="index"
                  >
                    <router-link
                      :to="subSubitem.link"
                      class="side-nav-link-ref"
                      v-if="!subSubitem.isHidden"
                      >{{ $t(subSubitem.label) }}</router-link
                    >
                  </li>
                </ul>
              </li>
            </div>
          </ul>
        </li>
      </template>
    </ul>
  </div>
  <!-- Sidebar -->
</template>
